import axios from "src/lib/axios";

//quotation find all admin
export const getQuotationList = ({
  keyword = null,
  page = null,
  page_size = null,
  status = "all",
}) => {
  return axios.get(`/requests/quotations/admin`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      order_case: "desc",
    },
  });
};
export const getQuotationDetail = (id) =>
  axios.get(`/requests/quotations/${id}`);

export const updateStatusProductQuotationPDF = (id, data) => {
  return axios.patch(`/requests/quotations/pdf/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};
export const createQuotation = (params) => {
  // if (orderId !== null) {
  //   return axios.post(`/requests/quotations/admin?order_id=${orderId}`, params, {
  //     headers: {
  //       "Content-Type": "multipart/form-data", // do not forget this
  //     },
  //   });
  // } else {
  //   return axios.post(`/requests/quotations/admin`, params, {
  //     headers: {
  //       "Content-Type": "multipart/form-data", // do not forget this
  //     },
  //   });
  // }
  return axios.post(`/requests/quotations/admin`, params, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

export const createQuotationRefOld = (params) => {
  return axios.post(`/requests/new-quotations/admin`, params, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};
export const updateQuotation = (params) => {
  return axios.patch(`/requests/quotations/admin`, params, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};
